import {
  Button,
  Text,
  Heading,
  Link,
  Box,
  Image,
  Divider,
  Stack
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { ArrowForwardIcon } from "@chakra-ui/icons";

import homeImage1 from "../images/home-1.svg";
import homeImage2 from "../images/home-2.svg";
import homeFinMadeSimple from "../images/home-fin-made-simple.svg";
import homeImage3 from "../images/undraw_prioritise_tgdh.png";

function HomeView() {
  return (
    <>
      <Stack bg="#163F6D" color="white" px={4} pt={2} pb={4} flex="1 0 auto">
        <Stack
          direction="column"
          mt={8}
          textAlign="center"
          alignItems="center"
          marginX="auto"
        >
          <Heading
            fontSize={24}
            lineHeight="1.4"
            fontWeight="bold"
            mb={6}
            width="90%"
            marginX="auto"
          >
            9 out of 10 car buyers don’t understand their finance options
          </Heading>
          <Text mb={2}>
            That often means they choose a deal that's not right for them.
            ClearDrive, part of the Compare The Market family, is here to fix
            that for you.
          </Text>
          <Text mb={2} fontWeight="bold">
            Just answer a few simple questions.
          </Text>
          <Text mb={6}>
            We’ll search 30 of the leading car finance providers, comparing
            their best deals and select the ones that best match your needs and
            situation. And we can email the results and information in a handy
            pack for you too.
          </Text>

          <Link as={RouterLink} to="/preamble">
            <Button
              colorScheme="blue"
              px={12}
              py={6}
              mb={4}
              lineHeight={0}
              minWidth="250px"
            >
              Let's go
            </Button>
          </Link>
          <Button
            variant="link"
            color="white"
            fontSize="12px"
            my={5}
            rightIcon={<ArrowForwardIcon />}
          >
            Get a previous quote
          </Button>
        </Stack>
      </Stack>
      <Box
        mx="auto"
        width="0"
        height="0"
        borderLeft="30px solid transparent"
        borderRight="30px solid transparent"
        borderTop="30px solid #163F6D"
        mb={0}
      ></Box>
      <Box px={4} pt={9} pb={16}>
        <Stack spacing={8} align="center">
          <Stack spacing={5}>
            <Heading size="md">We’ll put you in control.</Heading>
            <Text mb={6}>
              From the way deals are presented through to the language used,
              it’s hardly surprising most drivers can’t choose the cheapest car
              finance option. We’re here to change that.
            </Text>
          </Stack>
          <Image src={homeImage2} />
          <Stack spacing={3}>
            <Stack>
              <Text fontWeight="bold">
                Understand your finance options and which are best for you.
              </Text>
              <Text>
                We explain the differences between each type and why it may be
                the best fit for you
              </Text>
            </Stack>
          </Stack>
          <Image src={homeImage3} width="60%" />
          <Stack spacing={3}>
            <Stack>
              <Text fontWeight="bold">
                Then we search and compare all the finance options offered by 30
                different providers.
              </Text>
              <Text>
                This will give you the best suitable deals complete with total
                costs and monthly repayments.
              </Text>
            </Stack>
          </Stack>
          <Image src={homeImage1} />
          <Stack spacing={3}>
            <Stack>
              <Text fontWeight="bold">Get a handy information pack</Text>
              <Text>
                We can email all the information to you, so you have it to hand
                when talking to dealers and can compare offers.
              </Text>
            </Stack>
          </Stack>
          <Link as={RouterLink} to="/preamble">
            <Button
              colorScheme="blue"
              px={12}
              py={6}
              lineHeight={0}
              minWidth="250px"
            >
              Let's go
            </Button>
          </Link>
        </Stack>
      </Box>
      <Box px={6} pt={12} pb={24} bg="#EFF0F6" mb={-12}>
        <Link
          as={RouterLink}
          to="/financial-guide"
          _hover={{ textDecoration: "none" }}
        >
          <Box
            bg="white"
            borderRadius={16}
            boxShadow="md"
            border="3px solid #ffffff"
            _hover={{ border: "3px solid #163F6D" }}
          >
            <Image src={homeFinMadeSimple} width="90%" mx="auto" />
            <Divider borderColor="#aaaaaa" />
            <Stack spacing={4} p={6}>
              <Heading size="sm">
                Car finance made simple
                <ArrowForwardIcon ml={1} fontSize={24} />
              </Heading>
              <Text>
                Learn about the differences between all the car finance options
              </Text>
            </Stack>
          </Box>
        </Link>
      </Box>
    </>
  );
}

export default HomeView;
